import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Icon,
} from '@material-ui/core';

import styles from './styles';

class EventHeaderDetails extends React.Component {
  render() {
    const {
      classes,
      event,
    } = this.props;

    return (
      <div className={classes.statContainer}>
        {
          event.tags
            && event.tags.length > 0
            && (
              <div className={classes.statContainer}>
                <Icon className={classes.statIcon}>local_offer</Icon>
                <div className={classes.statValue}>{event.tags.length}</div>
              </div>
            )
        }
        {
          event.comments
            && event.comments.length > 0
            && (
              <div className={classes.statContainer}>
                <Icon className={classes.statIcon}>forum</Icon>
                <div className={classes.statValue}>{event.comments.length}</div>
              </div>
            )
        }
        {
          event.eventUploads
            && event.eventUploads.length > 0
            && (
              <div className={classes.statContainer}>
                <Icon className={classes.statIcon}>attach_file</Icon>
                <div className={classes.statValue}>{event.eventUploads.length}</div>
              </div>
            )
        }
      </div>
    );
  }
}

EventHeaderDetails.propTypes = {
  classes: PropTypes.object,
  event: PropTypes.object,
};

EventHeaderDetails.defaultProps = {
  classes: {},
  event: {},
};

export default (withStyles(styles, { withTheme: true })(EventHeaderDetails));
